<template>
    <Modal
        v-model="isOpen"
        title="Dienst übernehmen"
    >
        <p>
            Wir buchen jetzt diesen Dienst auf dich um. Zur Sicherheit zeigen wir dir hier noch einmal warum <Ines/> dich nicht automatisch auf den Dienst umgebucht hat:
        </p>

        <ul v-if="messages.length > 0" class="gap-message-list">
            <li v-for="message in messages" :key="message">
                {{ message }}
            </li>
        </ul>

        <template #actions>
            <IonButton
                expand="block"
                color="primary"
                @click="emit('confirm')"
                :disabled="submitting"
            >
                Dienst buchen
            </IonButton>
        </template>
    </Modal>
</template>

<script setup lang="ts">
import {IonButton} from "@ionic/vue";
import {PropType} from "vue";
import Modal from "@/components/Modal.vue";
import Ines from "@/views/components/Ines.vue";

defineProps({
    messages: {
        type: Array as PropType<string[]>,
        required: false,
        default: () => [],
    },
    submitting: {
        type: Boolean,
        required: false,
        default: false,
    }
})

const isOpen = defineModel({type: Boolean, default: false})

const emit = defineEmits<{
    confirm: []
}>()
</script>

<style scoped lang="scss">
.gap-message-list {
    padding-left: 1.25rem;
    margin: 1rem 0 0;
}

.gap-message-list li + li {
    margin-top: 0.5rem;
}
</style>
